var map = {
	"./account-welcome-background-white.jpg": "d5ca",
	"./account-welcome-background.jpg": "56b2",
	"./confirmation/drinks.jpg": "31cc",
	"./confirmation/homescreen.jpg": "0bd0",
	"./confirmation/snacks.jpg": "7b84",
	"./confirmation/wallet.jpg": "ff4d",
	"./error-person.png": "09e9",
	"./fridge-onboarding/step-1.jpg": "a1d6",
	"./fridge-onboarding/step-2.jpg": "d788",
	"./fridge-onboarding/step-3.jpg": "122f",
	"./machine-types/drinks.png": "32c4",
	"./machine-types/fridge-front.png": "19d9",
	"./machine-types/fridge.png": "6ba6",
	"./machine-types/vending.png": "9056",
	"./not-found.gif": "c4ff",
	"./not-found.jpg": "b551",
	"./onboarding-checkout.jpg": "bbb3",
	"./onboarding-scan.jpg": "930b",
	"./onboarding-select.jpg": "71b6",
	"./quote-block-images/blue.jpg": "34e8",
	"./quote-block-images/orange.jpg": "ceb7",
	"./register-images/pink.jpg": "31de",
	"./register-images/yellow.jpg": "e009",
	"./server-error.gif": "d749",
	"./touch-intro.jpg": "ca53",
	"./vending.png": "919c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";